import { COHORT_RULES } from '../shared/q3';

/**
 * Pre-login marquee. It shows contest facts rather than names: nobody is
 * signed in yet, so there is no live data to show.
 */
const ITEMS = [
  `Rising Star · ₹${COHORT_RULES['Rising Star'].target} Cr total · min ₹${COHORT_RULES['Rising Star'].min} Cr Mandatory`,
  `Super Star · ₹${COHORT_RULES['Super Star'].target} Cr total · min ₹${COHORT_RULES['Super Star'].min} Cr Mandatory`,
  'Mandatory: Category II · NCD · Corporate FD — the non-negotiable mix',
  'Live ranks · your exact gap to qualify · a daily pace check',
  "Don't just watch the leaderboard. Change it.",
];

export default function HomeTicker() {
  const track = [...ITEMS, ...ITEMS];
  return (
    <div className="sk-ticker" aria-label="Shakti Q3 at a glance">
      <div className="sk-ticker-label">Q3 at a glance</div>
      <div className="sk-ticker-viewport">
        <div className="sk-ticker-track">
          {track.map((t, i) => (
            <span key={i} className="sk-ticker-item" aria-hidden={i >= ITEMS.length}>
              {t}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
